import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { SignIn } from './pages/SignIn';
import { CampaignList } from './pages/CampaignList';
import { CampaignPlay } from './pages/CampaignPlay';
import { Dashboard } from './pages/Dashboard';
import { Admin } from './pages/Admin';
import { ProtectedRoute } from './components/ProtectedRoute';
import { ThemeSelector } from './components/ThemeSelector';
import { LandingEditorial } from './pages/LandingEditorial';
import { HowItWorks } from './pages/HowItWorks';
import { Privacy } from './pages/Privacy';
import { useAppConfig } from './hooks/useAppConfig';
import { UserProvider } from './contexts/UserContext';

function AppContent() {
  const location = useLocation();
  const { config } = useAppConfig();

  // Set editorial-fantasy theme on demo route
  useEffect(() => {
    if (location.pathname === '/theme-demo') {
      document.documentElement.setAttribute('data-theme', 'editorial-fantasy');
    }
  }, [location.pathname]);

  // Set page title
  useEffect(() => {
    if (config?.title) {
      document.title = config.title;
    }
  }, [config?.title]);

  return (
    <>
      <ThemeSelector />
      <Routes>
        <Route path="/sign-in" element={<SignIn />} />
        <Route
          path="/theme-demo"
          element={
            <LandingEditorial
              onCreateCampaign={() => console.log('Create campaign demo')}
              onSeeHowItWorks={() => console.log('See how it works demo')}
            />
          }
        />
        <Route
          path="/how-it-works"
          element={
            <HowItWorks
              onStartQuest={() => console.log('Start quest from how-it-works')}
            />
          }
        />
        <Route path="/privacy" element={<Privacy />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaigns"
          element={
            <ProtectedRoute>
              <CampaignList />
            </ProtectedRoute>
          }
        />
        <Route
          path="/campaigns/:campaignId"
          element={
            <ProtectedRoute>
              <CampaignPlay />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <Admin />
            </ProtectedRoute>
          }
        />
        <Route path="/" element={<Navigate to="/campaigns" replace />} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <UserProvider>
        <AppContent />
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;
